import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Select from "react-select";
import { LayersIcon, SaveAllIcon, SaveIcon, Search } from "lucide-react";
import { getProfileFromToken } from './config'; 
import MHeader from './header';
import Mfooter from './footer';
import config from "./config";
// --- Funzioni e config di ESEMPIO (decommenta le tue importazioni reali) ---

const customStyles = {
  control: (base) => ({
    ...base,
    width: "80%",  // Cambia larghezza
    minHeight: "40px", // Altezza minima
    fontSize: "16px",  // Dimensione testo
  }),
};
function AddImg({ user }) {

  const navigate = useNavigate();

  // --- Logica di "guardia" (route guard) ---
  useEffect(() => {
    let profile = getProfileFromToken();
    if (profile !== "Admin") {
      navigate("/");
    }
  }, [navigate]);

  // --- Stato per i dati del Form ---
  const [luoghi, setLuoghi] = useState([]); // Per l'elenco nel <select>
  const [selectedLuogo, setSelectedLuogo] = useState(''); // L'ID del luogo scelto
  const [file, setSelectedFile] = useState('');
  
  useEffect(() => {
    
     fetch(config.apiUrl+"/luogo")
      .then((res) => res.json())
      .then((data) => setLuoghi(data))
      .catch((error) => console.error("Errore nel fetch dei luoghi:", error))
  }, []); // L'array vuoto [] significa "esegui solo al montaggio"



  // --- Funzione per inviare il form completo ---
  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!selectedLuogo) {
      alert("Seleziona un luogo prima di salvare.");
      return;
    }
    
    const formData = new FormData();
    
    formData.append('id_luogo', ""+selectedLuogo.value);
    formData.append('file', file);

    try {
      const response = await fetch(config.apiUrl + '/newimg', { // L'API che hai richiesto
        method: 'POST',
        headers: {
          "Authorization": "Bearer " + localStorage.getItem("token")
        },
        body: formData,
      });

      if (response.ok) {
        alert(`Immagine aggiunta con successo!`);
        navigate("/");
      } else {
        alert('Errore durante il salvataggio immagine.');
      }
    } catch (error) {
      console.error('Errore:', error);
      alert('Si è verificato un errore durante il salvataggio.');
    }
  };

   const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  return (
    <div className="App">
      <h2 className="App-header">{config.appName}</h2>
      <MHeader />
      <p><small>utente: {user}</small></p>
      <div className="relative"></div>
      
      <h2>Aggiungi Immagine a un Luogo</h2>
      
      {/* Il form principale invia tutto alla fine */}
      <form onSubmit={handleSubmit}>
        
        {/* 1. Selezione Luogo */}
        <div>
          <label>Seleziona Luogo:</label><p></p>
            <Select
            options={luoghi}
            value={selectedLuogo}
            onChange={setSelectedLuogo}
            placeholder="Seleziona un luogo..."
            isClearable
          />
        <Search styles={customStyles} size={1} />

   
        </div>

        {/* 2. Sezione per aggiungere i singoli layer (non invia il form) */}
        <div style={{ border: '1px solid #ccc', padding: '1rem', margin: '1rem 0', borderRadius: '8px' }}>
          <div>
          <p></p><label>File da caricare:</label><p></p>
            <input 
                        type="file" 
                        id="FL"
                        onChange={handleFileChange}
                        accept=".png,.jpg,.jpeg" 
                       
                        />
          
          
          </div>
          {/* Bottone per aggiungere alla lista (type="button" per non inviare il form) */}
          
        </div>

        {/* 3. Elenco dei layer pronti per l'invio */}
        
        
        {/* 4. Bottone di invio finale */}
        <button type="submit"><SaveAllIcon className="mr-2" /><br/>Salva e Associa Immagine</button><p></p>
      </form>
      
      <Mfooter/>
    </div>
  );
}

export default AddImg;
